var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 63,
    viewBox: "0 0 69 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63751 20.6914H0V42.3108H9.63751L27.8478 55.9167C27.8478 55.9167 31.1877 58.7384 31.1877 55.8254C31.1877 52.9058 31.1877 9.40883 31.1877 6.75397C31.1877 4.4663 28.2499 6.70057 28.2499 6.70057L9.63751 20.6914Z",
    fill: "#130F40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.563 16.4721C40.5999 15.5063 39.0515 15.5063 38.0994 16.4721C37.1363 17.4379 37.1363 19.0046 38.0994 19.9615C41.2494 23.146 42.8111 27.274 42.8155 31.4377C42.8111 35.6102 41.2494 39.765 38.0994 42.9339C37.1363 43.8997 37.1363 45.4619 38.0994 46.4344C38.5744 46.9195 39.1995 47.1554 39.8334 47.1554C40.4541 47.1554 41.0837 46.9195 41.563 46.4344C45.6606 42.2975 47.7193 36.852 47.7149 31.4377C47.7215 26.0189 45.6628 20.6024 41.563 16.4721Z",
    fill: "#130F40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2074 8.69449C47.2399 7.72423 45.6915 7.72423 44.735 8.69449C43.7852 9.66252 43.7852 11.2247 44.735 12.1928C50.032 17.5247 52.6695 24.4768 52.6783 31.4577C52.6695 38.4765 50.0431 45.4597 44.735 50.8228C43.7808 51.7886 43.7852 53.3442 44.735 54.3166C45.2188 54.7884 45.8439 55.0332 46.4734 55.0332C47.0986 55.0332 47.7281 54.7884 48.2074 54.3166C54.4631 47.9966 57.5777 39.7138 57.5777 31.4577C57.5777 23.2283 54.4388 14.9789 48.2074 8.69449Z",
    fill: "#130F40"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3451 0.727693C55.3909 -0.242564 53.838 -0.242564 52.8771 0.727693C51.9273 1.6935 51.9273 3.26016 52.8771 4.21706C60.3587 11.7544 64.094 21.5949 64.094 31.4666C64.094 41.3673 60.3698 51.2367 52.8771 58.7896C51.9184 59.7532 51.9273 61.3243 52.8771 62.2834C53.3609 62.7619 53.9904 63 54.6199 63C55.2406 63 55.8658 62.7619 56.3451 62.2834C64.7876 53.7714 69.0022 42.6001 69 31.4644C69.0022 20.3487 64.7655 9.21077 56.3451 0.727693Z",
    fill: "#130F40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audioIcon.c76db96b28fd0e3e2ee8fd356e4675db.svg";
export { ForwardRef as ReactComponent };